import { render, staticRenderFns } from "./the-header-help-popover-footer.vue?vue&type=template&id=5b757576&scoped=true"
import script from "./the-header-help-popover-footer.vue?vue&type=script&lang=js"
export * from "./the-header-help-popover-footer.vue?vue&type=script&lang=js"
import style0 from "./the-header-help-popover-footer.vue?vue&type=style&index=0&id=5b757576&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b757576",
  null
  
)

export default component.exports